import React from 'react';
import { Text } from '../text';
import { IS_NATIVE } from '@r3l/common';
import { Pressable as RPressable } from 'react-native';
import { Link } from './link';
import { LinkProps, StyleProps } from './types';

export const InlineLink = ({
  c,
  hc,
  hu,
  children,
  sx,
  hoverSx,
  disabled,
  variant,
  ...linkProps
}: StyleProps & LinkProps): JSX.Element => {
  if (disabled) return <Text sx={{ color: c, ...sx }}>{children}</Text>;

  if (IS_NATIVE)
    return (
      <Link {...linkProps} inline>
        <Text sx={{ color: c, ...sx }}>{children}</Text>
      </Link>
    );

  const color = c || sx?.color || 'blue';
  if (sx?.color) delete sx.color;

  return (
    <RPressable>
      {({ hovered }: any) => (
        <Link {...linkProps}>
          <Text
            variant={variant}
            sx={{
              color: hovered && hc ? hc : color,
              textDecorationLine: hovered && hu ? 'underline' : 'none',
              textDecorationColor: hovered && hu ? hc || color : color,
              ...sx,
              ...(hovered ? hoverSx : {}),
            }}
          >
            {children}
          </Text>
        </Link>
      )}
    </RPressable>
  );
};
